import { makeObservable, observable, action } from 'mobx';

export type GenderType = 'male' | 'female' | 'nonBinary';

export class GenderStore {
  selectedGender: GenderType | null = null;

  constructor() {
    makeObservable(this, {
      selectedGender: observable,
      setGender: action,
    });
  }

  setGender(inputGender: GenderType) {
    this.selectedGender = inputGender;
  }
}

export const genderStore = new GenderStore();
